import { mapGetters } from 'vuex'

const customers = {
  computed: {
    ...mapGetters({
      user_data: 'userData',
      lang: 'getLanguage',
      get_data: 'getData'
    })
  },
  methods: {
    getHistory (type) {
      return (this.get_global.defaults.options.customers.history && typeof this.get_global.defaults.options.customers.history[type - 1] !== 'undefined' ? this.get_global.defaults.options.customers.history[type - 1] : {})
    },

    saveCustomer (customer) {
      if (this.$refs.SaveForm.validate()) {
        this.$store.dispatch('saveData', { page: 6, data: customer, item: this.id })
      }
    },
    deleteCustomer (customer) {
      this.$store.dispatch('setOverlay', true)
      this.$root.$dialog.confirm({
        text: `${this.lang.customers.dialog.deleteConfirm} ${customer.name}?`,
        title: this.lang.confirm.title,
        waitForResult: true
      }).then(res => {
        this.$store.dispatch('setOverlay', false)
        if (res) this.$store.dispatch('saveAction', { page: 6, type: 1, item: customer.id })
      })
    }
  }
}
export default customers
